/*
 * @Desc: 
 * @Author: lc
 * @Date: 2024-12-26 16:01:23
 * @LastEditors: lc
 * @LastEditTime: 2025-03-19 17:01:27
 */
/**
  * 充值卡 接口的统一出口
  */
import axios from '.././http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块，把请求字段直接映射过来


// 接口请求地址
const api = '/c-api/jinfeixibi/';

const studylevellog = {
    // 列表
    list (params) {
        return axios.get(api + 'studylevellog/list', { params: params })
    },
    edit (params) {
        return axios.post(api + 'studylevellog/edit', qs.stringify(params))
    },
}


// 导出接口
export default studylevellog